import * as R from "ramda";
import { isNilOrEmpty } from "utils";

const flowConfigRules = [
  {
    id: "exclude-paypal-when-settings-and-flowConfig",
    hasOpinion: R.propEq("provider", "paypal"),
    // if the integrator is configured to allow for the exclusion and they ask as part of the
    // flowConfig, return false to exclude the PM
    process: (pm, flowConfig, config) => !(config.allowExcludePaypal && flowConfig.excludePaypal),
  },
];

const processWithFlowConfig = (pm, flowConfig, config) =>
  R.pipe(
    R.filter((rule) => rule.hasOpinion(pm, flowConfig, config)),
    R.all((rule) => rule.process(pm, flowConfig, config))
  )(flowConfigRules);

const paymentMethodRules = [
  {
    id: "wallet-only",
    hasOpinion: R.propEq("provider", "wallet"),
    process: () => true,
  },
];

const processWithPMRules = (pm) =>
  R.pipe(
    R.filter((r) => r.hasOpinion(pm)),
    R.all((r) => r.process(pm))
  )(paymentMethodRules);

const processExcludes = (pm, config) =>
  isNilOrEmpty(config.exclude) || !R.contains(pm.provider, config.exclude);

const processIncludes = (pm, config) =>
  isNilOrEmpty(config.include) || R.contains(pm.provider, config.include);

const byFilterRules = (config, flowConfig) => (pm) => {
  return (
    processWithFlowConfig(pm, flowConfig, config) &&
    processWithPMRules(pm) &&
    processExcludes(pm, config) &&
    processIncludes(pm, config)
  );
};

/*
 * Calculate the final list of payment methods to offer by filtering the given methods based on the
 * inputs.
 *
 * The algorithm considers a number of concerns:
 * * the (static) limitations of the flow;
 * * the integrator-specific configuration of the flow;
 * * the runtime flowConfig;
 * * the runtime attributes of the payment method;
 *
 */
const getFinalPaymentMethods = (methods, chooserConfig, flowConfig) =>
  R.filter(byFilterRules(chooserConfig, flowConfig), methods);

export default getFinalPaymentMethods;
